import { Component, OnInit } from '@angular/core';
import { BaseFormComponent } from 'src/app/shared/base/base-form.component';
import { AuthService } from '../../../../core/auth.service';
import { LoadingService } from '../../../../core/loading.service';
import { DialogService } from '../../../../core/dialog.service';
import { AlertService } from '../../../../core/alert.service';
import { UtilityService } from '../../../../core/utility.service';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseService } from 'src/app/shared/base/base.service';
import { Constants } from 'src/app/app.constants';
import { Template, TemplateAttributeDataType } from '../templates.models';
import { ValueLabel } from 'src/app/shared/base/base.models';
import { TranslatorService } from 'src/app/core/translator.service';

@Component({
  selector: 'app-templates-form',
  templateUrl: './templates-form.component.html',
  styleUrls: ['./templates-form.component.scss']
})
export class TemplatesFormComponent extends BaseFormComponent implements OnInit {
  public templateAttributeDataTypes: ValueLabel[] = [];

  constructor(
    public authService: AuthService,
    public loadingService: LoadingService,
    public translatorService: TranslatorService,
    public utilityService: UtilityService,
    protected activatedRoute: ActivatedRoute,
    protected baseService: BaseService,
    protected dialogService: DialogService,
    protected router: Router,
    protected alertService: AlertService
  ) {
    super(authService, loadingService, translatorService, utilityService, activatedRoute, baseService, dialogService, router, alertService)
  }

  ngOnInit(): void {
    this.authorities.init('CUD_CNF', 'R_CNF', 'CUD_CNF', 'CUD_CNF');
    this.url = `${Constants.contextPath}/templates`;
    this.prepareLookupData();
    this.prepareFormData(new Template(), (response: Template) => {
      response.breadcrumbsId = response.name;
      return response;
    });
  }

  prepareLookupData() {
    this.templateAttributeDataTypes = this.utilityService.prepareLookupItems(this.utilityService.enumToSelectArray(TemplateAttributeDataType, true), 'value', 'label', 'ENUMS.TEMPLATE_ATTRIBUTE_DATA_TYPES.');
  }

  onCellHoverChanged(event: any) {
    if (event.rowType === "data" && event.column.dataField === "Type") {
      console.log(event);
      
      // this.TooltipTarget = event.cellElement;
      // if (event.eventType === 'mouseover') {
      //   this.ToolTipText = event.data.Tooltip;
      }
    }

  rowChanges(){
    this.pendingChanges = true;
  }

}
